// GENERATED by generateConfigRelease.js — do not edit.
// Client id handed to the PayPal JS SDK in CartModal. Switch environments by
// rebuilding: `npm run build-testing` or `npm run build-release`.

export const PAYPAL_CLIENT_ID = "ATCwXMSFa7w0a9rzFBbEkJ3OWc_OTevJG5ohVGLskTQVZfvDAyd2bjsLJWMK9qNiIUv_Tk16XW0eLau7";
export const PAYPAL_ENV: "live" | "sandbox" = "live";
